import { render, staticRenderFns } from "./AdminChangelogInnerTable.vue?vue&type=template&id=2d9616c8&"
import script from "./AdminChangelogInnerTable.vue?vue&type=script&lang=ts&"
export * from "./AdminChangelogInnerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports